import { CompaniesService } from "./companies"
import { ConfigService } from "./config"
import { DownloadsService } from "./downloads"
import { ShipmentsService } from "./shipments"
import { TfsService } from "./tfs"
import { TfsMetadataService } from "./tfsMetadata"
import { UsersService } from "./users"

export * from "./tfs"

export const Api = {
	companies: new CompaniesService(),
	config: new ConfigService(),
	downloads: new DownloadsService(),
	shipments: new ShipmentsService(),
	tfs: new TfsService(),
	tfsMetadata: new TfsMetadataService(),
	users: new UsersService(),
}
